import axiosInstance from './axiosInstance';

const settingsActions = (merchant, settingsId, status) =>
  axiosInstance.patch(
    `/internal/admin/merchants/${merchant}/settings/${settingsId}`,
    { next_state: status },
  );

export default settingsActions;
